import type { DomainErrorCode } from "./domainCodes";

export interface DomainErrorOptions {
  cause?: unknown;
}

/**
 * Represents an expected business-rule or validation failure (not a transport bug).
 */
export class DomainError extends Error {
  readonly code: DomainErrorCode | string;

  constructor(code: DomainErrorCode | string, message: string, options?: DomainErrorOptions) {
    super(message, options?.cause !== undefined ? { cause: options.cause } : undefined);
    this.name = "DomainError";
    this.code = code;
  }
}
